module.exports = __webpack_public_path__ + "static/media/KentIckler.2b1a5611.jpg";